/* React */
import React from "react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import {
  setName,
  clearError,
} from "src/redux/features/custom-cohorts/customCohortsSlice";
import { RootState } from "src/redux/store";

/* Components */
import SimpleInput from "src/components/shared/input/simple-input/SimpleInput";

/* Stylesheet */
import styles from "./CohortName.module.scss";

/* Interfaces */
interface CustomCohortNameProps {
  name: string;
  disabled: boolean;
}

const CohortName: React.FC<CustomCohortNameProps> = ({
  name,
  disabled,
}) => {
  const dispatch = useDispatch();

  const customCohortsState = useSelector(
    (state: RootState) => state.customCohorts
  );

  const { error } = customCohortsState;

  return (
    <div className={styles.cohort_name}>
      <SimpleInput
        type={"text"}
        placeholder={name}
        value={name}
        onChange={(value) => dispatch(setName(value))}
        error={error}
        clearError={() => dispatch(clearError())}
        disabled={disabled}
      />
    </div>
  );
};

export default CohortName;
